import { fg } from '@atlaskit/platform-feature-flags/fg';

import { generateHashFromVariables } from '../../../utils/caching/common/key-generator';
import { inMemoryCache } from '../../../utils/caching/in-memory';

const cache = inMemoryCache<any>();

type LeapQueryRequestProps = {
	query: string;
	product: string;
	cloudId?: string;
};

type LeapQueryResponseProps = {
	title: number;
	candidates: string[];
};

export const getLeapQuery = ({
	query,
	product,
	cloudId,
}: LeapQueryRequestProps): Promise<LeapQueryResponseProps> => {
	const relativeLeapQueryUrl = `/gateway/api/assist/api/ai/v2/ai-feature/leapquery`;

	const body = {
		ai_feature_input: { query },
	};

	const sendCloudId = fg('rovo_fps_send_leap_query_cloudid');

	const cacheKey = sendCloudId
		? generateHashFromVariables({ query, product, cloudId })
		: generateHashFromVariables({ query });

	return cache.inMemoryDecorator(cacheKey, () =>
		fetch(relativeLeapQueryUrl, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				'Content-Type': 'application/json',
				'X-Product': product,
				'X-Experience-Id': 'query-suggestion',
				...(sendCloudId && cloudId ? { 'X-Cloudid': cloudId } : {}),
			},
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
			})
			.then((data) => {
				// return empty skeleton response if response is not ok
				// UI will treat this response as no results
				return data?.ai_feature_output || { title: 0, candidates: [] };
			})
			.catch(() => {
				// return empty skeleton response if response is not ok
				// UI will treat this response as no results
				return { title: 0, candidates: [] };
			}),
	);
};
